<template>
  <button ref="video-button" class="video-button" style="opacity: 0; transform:translateY(10em);">WATCH VIDEO</button>
</template>

<script>
export default {
  name: "WatchVideoButton",
  mounted() {
    if(this.$refs['video-button']){
      this.$tween.to(this.$refs['video-button'], 0.6, {opacity:1.0, y:0})
    }

  }
}
</script>

<style scoped>
.video-button {
  font-size: 1vw;
  position: absolute;
  bottom: 0;
  left: 0;
  margin: 4em 6em;
  padding: 1em 2em;
  color: white;
  border: 2px solid #cc0000;
  background-color: #cc0000;
}

.video-button:hover {
  background-color: white;
  color: #cc0000;
}
</style>